import React, { useEffect, useRef, useState } from 'react'
import styles from "./scss/createcampaign.module.scss"
import CustomStepper from '../../components/custom_components/stepper/stepperindex'

function Varianttype() {
  
    const [variantA, setVariantA] = useState(10);
    const [variantB, setVariantB] = useState(10);
    console.log("variantAB",variantA,variantB);
    const [isDragging, setIsDragging] = useState(false);
    const containerRef = useRef<HTMLDivElement>(null);

    const winner = 100 - (variantA + variantB);

    const handleMouseMove = (e: MouseEvent) => {
        try {
            if (!isDragging || !containerRef.current) return;

            const rect = containerRef.current.getBoundingClientRect();
            const offsetX = e.clientX - rect.left;
            const containerWidth = rect.width;

            let totalAB = Math.round((offsetX / containerWidth) * 100);

            // Clamp totalAB to max 90

            if (totalAB > 50) totalAB = 50;
            if (totalAB < 20) totalAB = 20;

            // Distribute A and B equally (you can modify to support two dividers later)
            const newA = Math.round(totalAB / 2);
            const newB = totalAB - newA;

            setVariantA(newA);
            setVariantB(newB);
        } catch (error) {
            console.log('err', error)
        }

    };

    const handleMouseUp = () => {
        try {
            setIsDragging(false);
        } catch (error) {
            console.log("err", error)
        }

    };

    const handleMouseDown = () => {
        try {
          
                setIsDragging(true);
        } catch (error) {
            console.log("err", error)
        }

    };

    useEffect(() => {
        window.addEventListener("mousemove", handleMouseMove);
        window.addEventListener("mouseup", handleMouseUp);
        return () => {
            window.removeEventListener("mousemove", handleMouseMove);
            window.removeEventListener("mouseup", handleMouseUp);
        };
    }, [isDragging]);

  return (
    <div>

        
       
                <div className={styles.emailaimodal}>

                    <form className='formsectionsplit'>
                        <div className='formrow'>
                            <div className='rowleft'>
                                <label htmlFor="templatename">Test Type<span>*</span></label>
                            </div>
                            <div className='rowrightfull'>
                                <div className={styles.radiogrp}>
                                    <label className="radiolabel" htmlFor="radiolabel">
                                        <input
                                            type="radio"
                                            name="checklist"
                                            id="radiolabel"
                                          
                                        />
                                        A/B
                                    </label>
                                    <label className="radiolabel" htmlFor="radiolabel">
                                        <input
                                            type="radio"
                                            name="checklist"
                                            id="radiolabel"
                                           
                                        />
                                        Split
                                    </label>

                                </div>
                            </div>
                        </div>
                        <div className='formrow'>
                            <div className='rowleft'>
                                <label htmlFor="templatename">Variants</label>
                            </div>
                            <div className='rowrightfull'>
                          
                                <div className={styles.variantset}><span className={styles.variantname}>Variant</span> <div className={styles.varientidentify} style={{ backgroundColor: '#FF793D' }}>A</div></div>
                                <div className={styles.variantset}><span className={styles.variantname}>Variant</span> <div className={styles.varientidentify} style={{ backgroundColor: '#575CFF' }}>B</div></div>
                                
                            </div>
                        </div>
                        <div className='formrow'>
                            <div className='rowleft'>
                                <label htmlFor="templatename">Variant Distribution<span>*</span></label>
                            </div>
                            <div className='rowrightfull'>
                                {/* <div className={styles.varientchart}>
                                    <div className={styles.divider} style={{ transform: 'translateX(45px)' }} onClick={(e)=>console.log("data",e)}></div>
                                    <div className={styles.blockview} style={{ backgroundColor: 'red', width: '10%' }}>
                                        <span>A</span>
                                        <span>10%</span>
                                    </div>
                                    <div className={styles.blockview} style={{ backgroundColor: 'blue', width: '10%' }}>
                                        <span>B</span>
                                        <span>10%</span>
                                    </div>
                                    <div className={styles.blockview} style={{ backgroundColor: '#EDEFF0', width: '80%' }}>
                                        <span>Winner</span>
                                        <span>80%</span>
                                    </div>
                                </div> */}


                                {/* <div className={styles.varientchart} onClick={handleDrag} style={{ display: "flex", cursor: "pointer" }}>
                                    <div className={styles.divider} style={{ transform: 'translateX(45px)' }} onClick={(e)=>console.log("data",e)}></div>
                                    <div className={styles.blockview} style={{ backgroundColor: "red", width: `${variantA}%` }}>
                                        <span>A</span>
                                        <span>{variantA}%</span>
                                    </div>
                                    <div className={styles.blockview} style={{ backgroundColor: "blue", width: `${variantB}%` }}>
                                        <span>B</span>
                                        <span>{variantB}%</span>
                                    </div>
                                    <div className={styles.blockview} style={{ backgroundColor: "#EDEFF0", width: `${winner}%` }}>
                                        <span>Winner</span>
                                        <span>{winner}%</span>
                                    </div>
                                </div> */}


                                <div
                                    className={styles.varientchart}
                                    ref={containerRef}
                                >
                                    <div
                                        className={styles.divider}
                                        style={{
                                            left: `calc(${(variantA + variantB) != 100 ? (variantA + variantB) : 50}% - 3px)`,
                                        }}
                                        onMouseDown={handleMouseDown}
                                    />
                                    <div className={styles.blockview} style={{ backgroundColor: "#FF793D", width: `${variantA}%` }}>
                                        <span>A</span>
                                        <span>{variantA}%</span>
                                    </div>
                                    <div className={styles.blockview} style={{ backgroundColor: "#575CFF", width: `${variantB}%` }}>
                                        <span>B</span>
                                        <span>{variantB}%</span>
                                    </div>
                                    {!(variantA == 50 && variantB == 50) && <div className={styles.blockview} style={{ backgroundColor: "#EDEFF0", width: `${winner}%`, color: "#252526" }}>
                                        <span>Winner</span>
                                        <span>{winner}%</span>
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                      
                            <>
                                <div className='formrow'>
                                    <div className='rowleft'>
                                        <label htmlFor="templatename">Winning Criteria<span>*</span></label>
                                    </div>
                                    <div className='rowrightfull'>
                                       
                                    </div>
                                </div>

                                <div className='formrow'>
                                    <div className='rowleft'>
                                        <label htmlFor="templatename">A/B Test Window<span>*</span></label>
                                    </div>
                                    <div className='rowrightfull'>
                                        <div className={styles.twoselect}>
                                            <div className={styles.onesel}>
                                                
                                            </div>
                                            <div className={styles.onesel}>
                                              
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </>
                        
                    </form>
                    <div style={{display:"flex", alignItems:"center", gap:"12px"}}>
                       <button className='cancelbtn'> Cancel</button>
                       <button className='primarybtn'> Next</button>
                    </div>
                </div>
          
    </div>
  )
}

export default Varianttype